export default __webpack_public_path__ + "static/media/evenshotBG.d4897390.png";